'use client';

import { useTranslations } from 'next-intl';
import { EventService } from '@/shared/lib/event-service';
import { Icon } from '@/shared/ui/icon';
import { BottomPanelTab } from './bottom-panel-tab';
import { BottomPanelTabIconWrapper } from './bottom-panel-tab-icon-wrapper';
import { BottomPanelTabPremadeProps } from './types';

type Props = BottomPanelTabPremadeProps;
export const BottomPanelFavoriteItemsTab = (props: Props) => {
    const t = useTranslations();
    return (
        <BottomPanelTab
            icon={
                <BottomPanelTabIconWrapper>
                    <Icon name="heart" width={24} height={24} />
                </BottomPanelTabIconWrapper>
            }
            title={t('BOTTOM_PANEL.FAVORITE_ITEMS')}
            {...props}
            data-testid="bottom-panel-favorite-items-tab"
            onClick={() => EventService.trigger('account:favorite-items:view-detail')}
        />
    );
};
